(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phalanx-system"]) return;
  try {
    
document.querySelectorAll('[data-px-expiry]').forEach(el=>{if(Date.now()>=Date.parse(el.dataset.pxExpiry))el.hidden=true;});
function phalanxPreviewLinks(){const previewBrand=Boolean(document.querySelector('[data-px-preview-routes]'));document.querySelectorAll('a[href]').forEach(link=>{const url=new URL(link.href,location.origin);if(url.origin!==location.origin)return;if(!previewBrand)return;const match=url.pathname.match(/^(.*)\/pages\/(about-phalanx|phalanx-community)$/);if(match){const suffix=match[2]==='about-phalanx'?'about':'community';link.href=match[1]+'/pages/contact?view=phalanx-'+suffix;}});}phalanxPreviewLinks();document.addEventListener('shopify:section:load',phalanxPreviewLinks);document.addEventListener('click',phalanxPreviewLinks,true);

  } catch(e) { console.error(e); }
})();
})();
